import LoyaltyMeta from "../Meta/LoyaltyMeta";
import TemplateBreakdownPointsModel from "./TemplateBreakdownPointsModel";

export default class TemplateBreakdownModel {
  public meta: LoyaltyMeta = new LoyaltyMeta();
  public data: TemplateBreakdownPointsModel[] = [];
}
